export const UPDATE_ADMIN_FORM = [
  {
    name: "name",
    type: "text",
    placeholder: "Name",
    label: "Name:",
  },
  {
    name: "phone",
    type: "text",
    placeholder: "Phone Number",
    label: "Phone Number:",
  },
  {
    name: "email",
    type: "email",
    placeholder: "Email",
    label: "Email:",
  },
  {
    name: "username",
    type: "text",
    placeholder: "Username",
    label: "Username:",
  },
  {
    name: "currentPassword",
    type: "password",
    placeholder: "Current Password",
    label: "Current Password:",
  },
  {
    name: "newPassword",
    type: "password",
    placeholder: "New Password",
    label: "New Password:",
  },
  {
    name: "image",
    type: "image",
    placeholder: "Profile Image",
    label: "Profile Image:",
  },
];
